// Mock users data
export const mockUsers = [
  {
    id: 1,
    email: 'user@example.com',
    password: 'password123',
    username: 'JohnDoe'
  },
  {
    id: 2,
    email: 'jane@example.com',
    password: 'password456',
    username: 'JaneSmith'
  }
];

// Mock products data
export const mockProducts = [
  {
    id: 1,
    title: 'Vintage Leather Jacket',
    description: 'Classic brown leather jacket in excellent condition. Perfect for casual wear or motorcycle riding.',
    category: 'Clothing',
    price: 45,
    sellerId: 1,
    image: 'placeholder'
  },
  {
    id: 2,
    title: 'Antique Wooden Chair',
    description: 'Beautiful handcrafted wooden chair from the 1960s. Shows minimal wear and very sturdy.',
    category: 'Furniture',
    price: 30,
    sellerId: 1,
    image: 'placeholder'
  },
  {
    id: 3,
    title: 'iPhone 12 Pro',
    description: 'Used iPhone 12 Pro in good condition. 128GB storage, includes charger and case.',
    category: 'Electronics',
    price: 400,
    sellerId: 2,
    image: 'placeholder'
  },
  {
    id: 4,
    title: 'JavaScript Programming Book',
    description: 'Complete guide to modern JavaScript programming. Excellent condition, no markings.',
    category: 'Books',
    price: 15,
    sellerId: 2,
    image: 'placeholder'
  },
  {
    id: 5,
    title: 'Tennis Racket',
    description: 'Professional tennis racket, Wilson brand. Used but well maintained.',
    category: 'Sports',
    price: 25,
    sellerId: 1,
    image: 'placeholder'
  }
];

// Product categories
export const categories = [
  'Electronics',
  'Clothing',
  'Furniture',
  'Books',
  'Sports',
  'Home & Garden',
  'Toys',
  'Music',
  'Art',
  'Automotive'
];